import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { Advertisement } from '../components/Advertisement';

export const AdvertisementProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <Advertisement {...data} />
        </Provider>
    );
};

AdvertisementProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
